export default () => ({
  token          : null,
  impersonatedBy : null,
  lastAccess     : null,
  currentRole    : null,
  webComponents  : [],

  // deprecated
  tenantsRights     : [],
  applicationsRoles : { roles: [] },
  userTenant        : null,
  authMode          : null,

  // v3
  idToken      : null,
  accessToken  : null,
  refreshToken : null
});
